@use '../../sass/theme';
@use '../../sass/loader';

:host {
  appearance: unset !important;
}
:host([disabled]) {
  pointer-events: none;
  touch-action: none;
}
:host([disabled='false']) {
  pointer-events: auto;
  touch-action: auto;
}

$variants: primary, secondary, success, info, warning, danger, low, high;

@mixin get-variants() {
  @each $variant in $variants {
    &.#{$variant} {
      color: var(--jui-#{$variant}-color);
      & .likert__step {
        border: 2px solid var(--jui-#{$variant}-color);
        font-weight: 600;
        color: var(--jui-#{$variant}-color);

        &.sentiment {
          font-weight: normal;
        }

        &--selected {
          background-color: var(--jui-#{$variant}-color);
          color: var(--jui-#{$variant}-color--contrast);
        }
      }
    }
  }
}

.likert {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: transparent;
  font-family: var(--jui-font-family);

  .material-icons {
    font-family: var(--jds-theme-ff-icon);
  }

  &__hint {
    display: inline-flex;
    justify-content: space-between;
    color: var(--jui-text-color);
    font-weight: 500;
    font-size: 0.9rem;
    user-select: none;
  }

  &__steps {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin: var(--jds-space-stack);
    gap: var(--jds-space-sm);
    min-width: 100%;

    &--column {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      align-items: center;
      justify-content: space-between;
      gap: var(--jds-space);

      & .likert__step {
        width: 100%;
        box-sizing: border-box;
        height: auto;
        border-radius: var(--jui-border-radius);
        padding: var(--jds-space-inset-xs);
      }
    }
  }

  &__value {
    position: relative;
    user-select: none;

    &-hint {
      color: var(--jui-text-color);
      margin-left: var(--jds-space-xs);
      font-weight: var(--jds-theme-fw);
    }
  }

  &__step {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    border: 2px solid var(--jui-primary-color);
    font-weight: 600;
    color: var(--jui-primary-color);
    margin: 0 2px;
    flex: 0 0 auto;

    &--selected {
      background-color: var(--jui-primary-color);
      color: var(--jui-primary-color--contrast);

      &  .likert__value-hint {
        color: currentColor;
      }
    }

    &--readonly {
      cursor: initial;
    }

    &.sentiment {
      font-size: 24px;
      font-weight: 400;

      & .material-icons {
        line-height: 2;
      }
    }
  }

  @include get-variants;

  &.sm {
    font-size: 0.8rem;

    & .likert__step {
      height: 23px;
      width: 23px;
      &.sentiment {
        font-size: 16px;
      }
    }

    & .likert__hint {
      font-size: 0.8rem;
    }
  }

  &.lg {
    font-size: 1.1rem;
    & .likert__step {
      height: 50px;
      width: 50px;
      &.sentiment {
        font-size: 32px;
      }
    }

    & .likert__hint {
      font-size: 1.2rem;
    }
  }
}
